import { createFileRoute } from '@tanstack/react-router'
import { CustomerBuyerGroupsPage } from '@/features/customer/pages/buyer-groups'

export const Route = createFileRoute('/_authenticated/customer/buyer-groups')({
  component: CustomerBuyerGroupsPage,
})
